// extracted by mini-css-extract-plugin
export default {"containers":"PhoneInputstyles_containers__rdMXt","phoneInput":"PhoneInputstyles_phoneInput__ThWgV"};